import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment-timezone';
import Radio from '../../components/Common/Radio';
import Modal from '../../components/Modal';
import { setSelectedTerm } from '../../actions/orders';
import ClassesList from './ClassesList';
import Button from '../../components/Common/Button';
import { max } from '../../lodash';
import { flatten } from '../../utilities/helperUtility';
import Translation from '../../utilities/localizationUtility';

class Index extends Component {
  state = {
    termOptions: [],
  };

  UNSAFE_componentWillReceiveProps(newProps) {
    if (
      (this.state.termOptions.length === 0 && newProps.flattenTimeSlots.length)
      || this.props.variantSelected !== newProps.variantSelected
    ) {

      const termOptions = this.termOptions(newProps);
      const currentTerm = termOptions[0];

      if (currentTerm) {
        this.props.setSelectedTerm(currentTerm);
      }

      this.setState({ termOptions });
      this.props.onOptionsChange(termOptions);
    }
  }

  termOptions({
    terms, variantSelected, flattenTimeSlots, capacity,
  }) {
    const slotFilterVariant = flattenTimeSlots.map((slot) => {
      const item = slot.availability.find(x => x.external_id === variantSelected);
      item.term_id = slot.term_id;
      return item;
    });

    return terms.map((term) => {
      const slots = flattenTimeSlots.filter(x => x.term_id === term.id);
      const flatSlots = flatten(slots.map(x => x.availability.filter(x => x.external_id === variantSelected)));
      let sumEachVariantMaxBooking = 0;

      if (this.props.capacity_type == 0 && slots[0])  {
        slots[0].availability.find((availability) => {
          sumEachVariantMaxBooking += availability.bookings;
        })
      }

      return {
        ...term,
        disabled:
          capacity <= sumEachVariantMaxBooking
          || !slots.length
          || flatSlots.some(x => x.available < 1)
          || slots.some(x => moment(x.start).isBefore())
          || moment(term.start_date).isBefore(),
      };
    });
  }

  radioExtraContent({ id }) {
    const { style } = this.props.settings;

    return (
      <Button
        key={id}
        styled={{ ...style.button, padding: '6px 13px' }}
        disableFluid={true}
        onClick={() => this.openModal()}
      >
        Info
      </Button>
    );
  }

  render() {
    const { termSelected, setSelectedTerm, settings } = this.props;
    const { termOptions } = this.state;
    const t = new Translation(settings);

    return (
      <div>
        <Radio
          name="terms"
          styled={settings.style.button}
          value={termSelected.id}
          options={termOptions}
          onChange={value => setSelectedTerm(termOptions.find(x => x.id === +value))}
        >
          {option => this.radioExtraContent(option)}
        </Radio>

        <Modal
          title={t.key('classList')}
          getOpenFn={openFn => (this.openModal = openFn)}
        >
          <ClassesList />
        </Modal>
      </div>
    );
  }
}

export default connect(
  ({
    frames, product, order, settings,
  }) => ({
    capacity: product.data.capacity.quantity,
    capacity_type: product.data.capacity.type,
    settings: settings,
    terms: product.data.terms,
    termSelected: order.termSelected,
    variantSelected: order.variantSelected,
    flattenTimeSlots: frames.flattenTimeSlots,
  }),
  dispatch => ({
    setSelectedTerm: a => dispatch(setSelectedTerm(a)),
  }),
)(Index);
